import React from 'react'

export const Founder = ({ name, por, des, item, src }) => {
    return (
        // This is the Supporter card
        <div className='flex flex-col w-80 max-sm:w-60'>

            {/* // This is the image */}
            <div className='bg-white rounded-full h-16 w-16'>
                <img
                    src={src}
                    alt={`Pic of ${name}`}
                    className='rounded-full h-full w-full object-cover'
                />
            </div>

            {/* // This is the title */}
            <h3 className='font-semibold text-2xl mt-2'>
                {name}
            </h3>

            {/* // This is the description */}
            <p className='mt-1 font-light font-base text-sm'>
                {por}
            </p>

            {/* // This is the Comments */}
            <p className='mt-3 text-sm'>
                {des}
            </p>
        </div>
    )
}
